/**
 * useLabel hook
 * @returns {object}
 */
export const useLabel = () => {
    // todo: get from api

    // keep case
    return {
        addAdditionalPayment: 'Přidat příplatek',
        additionalPayment: 'Příplatek',
        backToHome: 'Zpět na úvodní stránku',
        cancel: 'Zrušit',
        currency: 'Kč',
        createdBy: 'vytvořil',
        doLogin: 'Přihlásit se',
        email: 'Email',
        errorCaught1: 'Omlouváme se',
        errorCaught2: 'nastala chyba',
        errorCaughtContent: 'Omlouváme se nastala chyba při zpracování akce. <br/>Zkuste to prosím znovu. Pokud problém přetrvává, <br/>neváhejte nás kontaktovat.',
        installApp: 'Chcete nainstalovat aplikaci na plochu?',
        installBtn: 'Instalovat',
        items: 'Položky',
        loading: 'Načítám...',
        login: 'Přihlášení',
        monthAndYear: 'Měsic a rok',
        noDataForDay: 'Nemáte nic na tento den',
        noLines: 'žadné řadky',
        noVat: 'bez DPH',
        note: 'Poznámka',
        pageNotFound: 'Stránka nenalezena',
        pageNotFoundContent: 'Omlouváme se, ale stránka, kterou hledáte, <br/>nebyla nalezena.',
        password: 'Heslo',
        qty: 'ks',
        report: 'Report',
        save: 'Uložit',
        selectMonthAndYear: 'Prosím, vyberte měsíc a rok',
        selectOrder: 'Prosím, vyberte objednávku ze seznamu',
        selectProduct: 'Prosím, vyberte produkt ze seznamu',
        selectWeek: 'Vybrat týden',
        show: 'Zobrazit',
        toCollect: 'K zabalení',
        toDoTotal: 'Celkem k broušení',
        total: 'celkem',
        totalDone: 'Celkem nabroušeno',
        totalPriceNoVat: 'Celkem bez DPH',
        tryAgain: 'Zkusit znovu',
    };
};
